<template>
  <v-menu nudge-bottom="4" nudge-left="50" top left>
    <template #activator="{ on }">
      <v-btn icon v-on="on" width="42" height="42">
        <v-icon color="primary">icon-more</v-icon>
      </v-btn>
    </template>
    <div class="datagrid__actions">
      <ui-button outlined color="primary" @click="goToDetails(item)">
        {{ $t("message.common.details") }}
      </ui-button>
      <ui-button
        v-if="showReviewsListBtn"
        outlined
        color="primary"
        @click="goToReviewsList(item)"
      >
        {{ $t("message.reviews.reviewsList") }}
      </ui-button>
    </div>
  </v-menu>
</template>

<script>
const GROUP_TYPES = {
  facility: "facility",
  category: "category",
  facility_group: "facility_group",
  city: "city"
};
import facilitiesService from "@/services/facilities";
import serviceHandler from "@/helpers/handlers/service";
export default {
  name: "ReviewsCategoriesTableActionColumn",
  props: {
    item: {
      type: Object,
      required: true
    },
    showReviewsListBtn: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    groupTypes() {
      return this.createGroupTypes(this.item.facility_id);
    },
    groupTypesReviews() {
      return this.createGroupTypes(this.item.gmb_address_id);
    }
  },
  methods: {
    createGroupTypes(facilityValue) {
      return {
        facility: { facility: facilityValue },
        facility_group: { facility_group: this.item.facility_group_id },
        city: { city: this.item.name },
        category: { tag_id: this.item.id }
      };
    },
    getDetails(item, selectionType = {}, groupTypes) {
      return {
        ...selectionType,
        ...groupTypes[this.item.grouped_by],
        withoutCategory:
          item.withoutCategory ||
          (item.withoutCategory !== false && this.$route.query.withoutCategory),
        ...(this.$route.query.tag_id && { tag_id: this.$route.query.tag_id })
      };
    },
    getItemDetails(item, selectionType = {}) {
      return this.getDetails(item, selectionType, this.groupTypes);
    },
    getReviewDetails(item) {
      return this.getDetails(item, {}, this.groupTypesReviews);
    },
    goToDetails(item) {
      const itemDetails = this.getItemDetails(item);
      this.$emit("go-to-details", itemDetails);
    },
    async getSelectionType(item) {
      if (item.facility_id) {
        const currentFacility = await serviceHandler(
          facilitiesService.getFacilityData(item.facility_id)
        );
        return {
          facility:
            currentFacility.facility_listings.address_group.gmb_address_id
        };
      }
      return this.getQueryParams(["facility", "facility_group", "city"]);
    },
    getQueryParams(params) {
      return params.reduce((acc, param) => {
        if (this.$route.query[param]) {
          acc[param] = this.$route.query[param];
        }
        return acc;
      }, {});
    },
    async goToReviewsList(item) {
      const selectionType = await this.getSelectionType(item);
      const itemDetails = this.getReviewDetails(item, selectionType);
      this.$emit("go-to-reviews-list", itemDetails);
    }
  }
};
</script>

<style lang="scss" scoped>
.datagrid {
  &__actions {
    background: white;
    padding: $spacing $spacing * 3;

    ::v-deep .v-btn {
      border-radius: 14px;
      @include font-size(12px);
      padding: 0 $spacing * 1.5 !important;
      height: 36px !important;
    }

    & > * + * {
      margin-left: $spacing * 1.5;
    }
  }
}
</style>
